export const filterHelper = (state) => {
  const filtered = Object.fromEntries(
    Object.entries(state).filter(([, value]) => value != null && value !== ""),
  );
  return new URLSearchParams(filtered).toString();
};
